import React from 'react';
import { Button, Spin } from 'components/ds';
import { ButtonLarge } from '../../../../components/Css';
import Logo from 'components/Logo';
import { useNavigate } from 'react-router-dom';
import { useGetTemplate } from 'modules/account/configs/SchemaConfig';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import {
  BannerWrapper,
  HelpBanner,
  ImageContainer,
  ImageWrapper,
  LinkCopyRigth,
  LinkRegister,
  LinkText,
  WelcomeContainer,
  WelcomeContentArea,
  WelcomeFooter,
  WelcomeHeader,
  WelcomeHeaderActions,
  WelcomeHeaderContainer,
  WelcomeHeaderLogo,
} from './Welcome.styles';
import { pageConfigs } from '../../configs/pageConfigs';
import { getDeviceType } from 'utils/useDeviceType';
import { useSchema } from 'modules/account/hooks/useSchema';
import { useClearAllData } from '../../hooks/useDataCleaner';
import useIsMobile from 'hooks/useIsMobile';
import FilteredModules from 'federation/FilteredModules';
import { useModulesContext } from 'services/providers/ModulesProvider';

const Welcome = () => {
  const { clearAllData } = useClearAllData();
  const { checkIsOpenFlow } = useSchema();
  const isMobile = useIsMobile();
  const modules = useModulesContext();
  const hasWelcomeContent = modules.some(
    (m: any) => m.componentPosition === 'content' && m.componentPage === 'welcome'
  );

  const { isLoading } = useGetTemplate(pageConfigs.welcome.template);

  const navigate = useNavigate();

  const theme = ApiLocalStorage.get('theme') || {};

  const handleRegisterClick = () => {
    clearAllData();
    const route = pageConfigs.welcome.navigateToRegister();
    navigate(route);
  };

  const handleGoToUserAuth = () => {
    const route = pageConfigs.welcome.navigateToUserName();
    navigate(route);
  };

  if (isLoading) {
    return (
      <WelcomeContainer>
        <Spin />
      </WelcomeContainer>
    );
  }

  const getBannerTheme = () => {
    if (theme?.login?.banner || theme?.login?.bannerMobile) {
      if (getDeviceType() === 'mobile') {
        return theme.login.bannerMobile as string;
      }

      if (getDeviceType() === 'desktop') {
        return theme.login.banner as string;
      }
    }

    return '';
  };

  const logo = theme?.login?.logo;
  const footerExtraInfo = theme?.welcome;
  const helpBanner = theme?.login?.HelpBanner;
  const welcomeHeader = theme?.login?.WelcomeHeader;

  const showHeader = welcomeHeader && !isMobile;
  const showFooter = isMobile || !welcomeHeader;

  return (
    <>
      <FilteredModules componentName="header" componentPage="welcome">
        {showHeader ? (
          <WelcomeHeader $isMobile={isMobile} className="welcome-header">
            <WelcomeHeaderContainer>
              <WelcomeHeaderLogo>
                <Logo />
              </WelcomeHeaderLogo>
              <WelcomeHeaderActions>
                <Button type="link" onClick={handleGoToUserAuth}>
                  Entre
                </Button>
                <Button type="highlight" onClick={handleRegisterClick}>
                  Cadastre-se
                </Button>
              </WelcomeHeaderActions>
            </WelcomeHeaderContainer>
          </WelcomeHeader>
        ) : <></>}
      </FilteredModules>

      {hasWelcomeContent ? (
        <WelcomeContentArea>
          <FilteredModules componentName="content" componentPage="welcome" />
        </WelcomeContentArea>
      ) : (
        <>
          <WelcomeContainer className="welcome-container" $isMobile={isMobile}>
            {logo && !showHeader && (
              <ImageWrapper>
                <Logo />
              </ImageWrapper>
            )}

            {getBannerTheme() && (
              <BannerWrapper>
                <ImageContainer
                  className="pwa-welcome-banner"
                  $bannerUrl={getBannerTheme()}
                  $isMobile={isMobile}
                  $hasHelpBanner={!!helpBanner}
                />
              </BannerWrapper>
            )}
            {showFooter && (
              <WelcomeFooter className="welcome-footer-container" $isMobile={isMobile}>
                <ButtonLarge
                  className="vert-welcome-sign vert-fml-welcome-button"
                  onClick={handleGoToUserAuth}
                >
                  Entrar
                </ButtonLarge>
                {checkIsOpenFlow() && (
                  <LinkRegister className="vert-welcome-signup welcome-footer-box">
                    Primeira vez aqui?
                    <LinkText onClick={handleRegisterClick}> Cadastre-se.</LinkText>
                  </LinkRegister>
                )}

                {footerExtraInfo && (
                  <div className="welcome-footer-box">
                    <span>{footerExtraInfo?.footerExtraInfo}</span>
                    <a
                      href={footerExtraInfo?.footerExtraInfoUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <LinkCopyRigth onClick={handleRegisterClick}>
                        {' '}
                        {footerExtraInfo?.footerExtraInfoUrl}
                      </LinkCopyRigth>
                    </a>
                  </div>
                )}
              </WelcomeFooter>
            )}
          </WelcomeContainer>
          {helpBanner && (
            <HelpBanner
              $isMobile={isMobile}
              dangerouslySetInnerHTML={{ __html: helpBanner?.description || '' }}
            />
          )}
        </>
      )}

      <FilteredModules componentName="footer" componentPage="welcome" />
    </>
  );
};

export default Welcome;
